import { Expose } from "class-transformer";
import { UserPrefectureBase } from "domain/model/base";

export default class UserPrefecture extends UserPrefectureBase {
  @Expose({name: "prefecture"})
  prefecture?: string;
};
